import React, { useEffect } from "react";
import { graphql } from "gatsby";
import Product from "../sections/Product";
import ProductDetails from "../sections/ProductDetails";
import ProductHowToUse from "../sections/ProductHowToUse";
import ProductIcons from "../sections/ProductIcons";
import ProductReviews from "../sections/ProductReviews";
import ProductRecommendations from "../sections/ProductRecommendations";
import Layout from "../layouts/default";
import { Helmet } from "react-helmet";
import { trackViewItem } from "../utils/analytics";
import { FontWrapper } from "../components/typography";

export const query = graphql`
  query Product($id: String) {
    contentfulProduct(id: { eq: $id }) {
      __typename
      slug
      shopifyId
      calloutIcons
      contentful_id
      seo {
        pageTitle
        pageDescription {
          pageDescription
        }
      }
      description {
        raw
      }
      howToUse {
        raw
      }
      howToUseVideo
      id
      images {
        file {
          url
        }
      }
      detailsImage {
        fluid(maxWidth: 900) {
          base64
          aspectRatio
          src
          srcSet
          srcWebp
          srcSetWebp
          sizes
        }
        file {
          url
        }
      }
      ingredientsImage {
        fluid {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      keyIngredients {
        raw
      }
      ingredients {
        raw
      }
      name
      scent {
        raw
      }
      shortDescription {
        shortDescription
      }
      texture {
        raw
      }
      variants {
        id
        name
        volumeOrSize
        individual {
          shopifyId
          price
          priceNumber
          sku
        }
        subscription {
          shopifyId
          price
          sku
        }
      }
      images {
        fluid(quality: 100) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
    }
    allContentfulProduct(filter: { id: { ne: $id }, enabled: { eq: true } }) {
      nodes {
        __typename
        id
        name
        slug
        shopifyId
        shortDescription {
          shortDescription
        }
        productImage {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        useImage {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        variants {
          individual {
            shopifyId
            price
          }
          subscription {
            shopifyId
            price
          }
          volumeOrSize
        }
      }
    }
    allContentfulProductSet(
      filter: { id: { ne: $id }, enabled: { eq: true } }
    ) {
      nodes {
        __typename
        id
        name
        slug
        customizable
        shortDescription {
          shortDescription
        }
        setItem {
          price
        }
        productImage {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        hoverImage {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        variants {
          individual {
            shopifyId
            price
          }
          subscription {
            shopifyId
            price
          }
          volumeOrSize
        }
      }
    }
  }
`;

export default function ProductTemplate({ data, location }) {
  const { allContentfulProduct, allContentfulProductSet } = data;

  // Merge products and sets, shuffle, and then grab first 2 for 'you might like' section
  const allProducts = allContentfulProduct.nodes.concat(
    allContentfulProductSet.nodes
  );
  const shuffledProducts = allProducts
    .sort(() => 0.5 - Math.random())
    .slice(0, 2);

  useEffect(() => {
    trackViewItem({
      item_id: atob(
        data.contentfulProduct.variants[0].individual.shopifyId
      ).replace("gid://shopify/ProductVariant/", ""),
      item_name: data.contentfulProduct.name,
      price: data.contentfulProduct.variants[0].individual.price,
      currency: "USD",
      klavyio_url: window.location.href,
      klavyio_img: data.contentfulProduct.images[0].file.url,
    });
  }, []);

  return (
    <Layout pathName={location.pathname}>
      <Helmet>
        <title>
          {data.contentfulProduct?.seo?.pageTitle ||
            data.contentfulProduct.name}
        </title>
        <meta
          name="description"
          content={data.contentfulProduct?.seo?.pageDescription.pageDescription}
        />
        <meta
          property="og:image"
          content={data.contentfulProduct.images[0].file.url}
        />
        {/*Floating Widget */}
        {/* <script src="//widget?.reviews.io/modern-widgets/floating.js"></script> */}

        {/* Product Reviews */}
        {/* <script src="https://widget?.reviews.io/polaris/build.js"></script> */}
        <script
          src="../../product-reviews-script.js"
          async
          defer
          title={data.contentfulProduct?.seo?.pageTitle}
        ></script>
      </Helmet>
      <Product product={data.contentfulProduct} />
      <ProductDetails product={data.contentfulProduct} />
      <ProductIcons product={data.contentfulProduct} />
      <ProductHowToUse product={data.contentfulProduct} />
      {/* ReviewsIo */}
      <FontWrapper>
        <div
          id="ReviewsWidget"
          style={{
            maxWidth: "1300px",
            padding: "0 20px",
            margin: "0 auto",
            marginTop: "50px",
          }}
        ></div>
      </FontWrapper>
      {/* <ProductReviews product={data.contentfulProduct} /> */}
      <ProductRecommendations
        products={shuffledProducts}
      ></ProductRecommendations>
    </Layout>
  );
}
